define.alias("shared/components/shared/color-picker/selector", "preview-grid/components/shared/color-picker/selector");